/**
 * Time synchronization data types
 */

export interface ClientServerTimeDiff {
  /**
   * `clientTime - serverTime` in milliseconds.
   * - Positive: client clock is ahead of server (e.g. +5000 = client is 5 s fast)
   * - Negative: client clock is behind server (e.g. -3000 = client is 3 s slow)
   *
   * To convert a client-side `Date.now()` timestamp to an approximate server
   * timestamp, subtract this value:
   *   `serverTs ≈ Date.now() - diffMs`
   */
  diffMs: number;
  /** Unix epoch milliseconds captured on the client at the moment of measurement */
  clientTime: number;
  /** Unix epoch milliseconds parsed from the server-provided ISO timestamp */
  serverTime: number;
  /** Human-readable description of the difference */
  description: string;
}

/** Threshold in milliseconds - only log/track if difference exceeds this value */
export const TIME_DIFF_THRESHOLD_MS = 10000; // 10 seconds
